import { render, staticRenderFns } from "./setRemarks.vue?vue&type=template&id=64eed40d&scoped=true"
import script from "./setRemarks.vue?vue&type=script&lang=js"
export * from "./setRemarks.vue?vue&type=script&lang=js"
import style0 from "./setRemarks.vue?vue&type=style&index=0&id=64eed40d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eed40d",
  null
  
)

export default component.exports